'use client';

import * as Sentry from '@sentry/nextjs';
import { Button } from '@stape-io/promo-shared-content/components';
import clsx from 'clsx';

import styles from './error.module.scss';

interface ErrorPageProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function ErrorPage({ error, reset }: ErrorPageProps) {
  Sentry.captureException(error);

  return (
    <div className={clsx(styles.errorContainer, 'text')}>
      <h3>Something went wrong</h3>
      <p>We are working to fix the issue. Please try again later.</p>
      {/* @ts-ignore */}
      <Button onClick={reset}>Try again</Button>
    </div>
  );
}
